import axios from "axios";

export async function logoutRequest() {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("Token de autenticação não encontrado");
  }

  const apiUrl = `${process.env.REACT_APP_API_DOMAIN}/manager/logout`;

  await axios.post(
    apiUrl,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

